export const KEY_PREFIX = '~:';
export const VALUE_PREFIX = '~u';
export const ROOT_SHAPE_ID = `${VALUE_PREFIX}00000000-0000-0000-0000-000000000000`; // 根图层的id.
export const ORIGIN_SHAPE_ID = `${VALUE_PREFIX}11111111-1111-1111-1111-111111111111`; // 原点图层的id.

export const DEFAULT_PROJECT_ID = `${VALUE_PREFIX}ebaf1ad6-e659-8067-8005-3b76baa1bf71`;
export const DEFAULT_PROJECT_NAME = '组件设计器';

export const DEFAULT_FILE_ID = `${VALUE_PREFIX}ebaf1ad6-e659-8067-8005-3b76d861e6ab`;
export const DEFAULT_FILE_NAME = '组件';

export const DEFAULT_PAGE_NAME = '新建视图';

// 布局块组件类型.
export enum ComponentsType {
  WebComponentsView = 'webComponentsView',
  FormView = 'formView',
  TableView = 'tableView',
  TabsView = 'tabsView',
  CardView = 'cardView',
  ChartView = 'chartView',
  TagView = 'tagView',
  TreeView = 'treeView',
  GanttView = 'ganttView',
  FlowChartView = 'flowChartView',
  KanbanView = 'kanbanView',
  ResourceLibraryView = 'resourceLibraryView',
  WorkEventView = 'workEventView',
  OnlineSheetView = 'onlineSheetView',
  CalendarView = 'calendarView',
  TimeLineView = 'timeLineView',
  MarkdownView = 'markdownView',
  SlideView = 'slideView',
}

// Penpot提供的图层类型.
export enum ShapeType {
  Frame = '~:frame',
  Group = '~:group',
  Rect = '~:rect',
  Circle = '~:circle',
  Text = '~:text',
  Path = '~:path',
}

// Penpot定义的渐变色类型.
export enum GradientType {
  Linear = '~:linear',
  Radial = '~:radial',
}

// Penpot定义的边框对齐方式.
export enum StrokesAlignment {
  Inner = '~:inner',
  Center = '~:center',
  Outer = '~:outer',
}

// 边框样式.
export enum StrokeStyle {
  Solid = '~:solid',
  Dotted = '~:dotted',
  Dashed = '~:dashed',
  Mixed = '~:mixed',
}

// Penpot中对应CSS的阴影类型，DropShadow是外边距，InnerShadow是内边距.
export enum ShadowStyle {
  DropShadow = '~:drop-shadow',
  InnerShadow = '~:inner-shadow',
}

// 路径命令.
export enum PathCommand {
  MoveTo = '~:move-to',
  LineTo = '~:line-to',
  CurveTo = '~:curve-to',
  ClosePath = '~:close-path',
}

// 水平对齐方式.
export enum TextAlign {
  Left = 'left',
  Center = 'center',
  Right = 'right',
  Justify = 'justify',
}

// 垂直对齐方式.
export enum VerticalAlign {
  Top = 'top',
  Center = 'center',
  Bottom = 'bottom',
}

// 字体样式.
export enum FontStyle {
  Normal = 'normal',
  Italic = 'italic',
}

// 文本装饰性线条.
export enum TextDecoration {
  Underline = 'underline',
  LineThrough = 'line-through',
  None = 'none',
}

// 文本大小写转换.
export enum TextTransform {
  Uppercase = 'uppercase',
  Capitalize = 'capitalize',
  Lowercase = 'lowercase',
}

// Penpot接口update-file的调用类型.
export enum UpdateFileType {
  AddShape = 'addShape',
  UpdateShape = 'updateShape',
  DeleteShape = 'deleteShape',
  AddPage = 'addPage',
  ModPage = 'modPage',
}

// Penpot接口update-file的hintOrigin类型.
export enum HintOrigin {
  AddShape = '~:app.main.data.workspace.shapes/add-shape',
  UpdateShapes = '~:app.main.data.workspace.changes/update-shapes',
  DeleteShapes = '~:app.main.data.workspace.shapes/delete-shapes',
  CreatePage = '~:app.main.data.workspace/create-page',
  RenamePage = '~:app.main.data.workspace/rename-page',
}

// Penpot接口update-file的change类型.
export enum ChangeType {
  SetOption = '~:set-option',
  MovObjects = '~:mov-objects',
  AddObj = '~:add-obj',
  ModObj = '~:mod-obj',
  DelObj = '~:del-obj',
  AddPage = '~:add-page',
  ModPage = '~:mod-page',
}

// Penpot键名映射.
export const ShapeConstants = {
  'content': '~:content',
  'children': '~:children',
  'objects': '~:objects',
  'root': ROOT_SHAPE_ID,
  'shape': '~#shape',
  'y': '~:y',
  'rx': '~:rx',
  'transform': '~:transform',
  'matrix': '~#matrix',
  'a': '~:a',
  'b': '~:b',
  'c': '~:c',
  'd': '~:d',
  'e': '~:e',
  'f': '~:f',
  'rotation': '~:rotation',
  'growType': '~:grow-type',
  'hideInViewer': '~:hide-in-viewer',
  'hideFillOnExport': '~:hide-fill-on-export',
  'type': '~:type',
  'name': '~:name',
  'width': '~:width',
  'transforming': '~:transforming',
  'points': '~:points',
  'point': '~#point',
  'x': '~:x',
  'proportionLock': '~:proportion-lock',
  'transformInverse': '~:transform-inverse',
  'id': '~:id',
  'pages': '~:pages',
  'file': '~:file',
  'data': '~:data',
  'pagesIndex': '~:pages-index',
  'penpotPointer': '~#penpot/pointer',
  'parentId': '~:parent-id',
  'frameId': '~:frame-id',
  'strokes': '~:strokes',
  'strokesAlignment': '~:stroke-alignment',
  'strokesColor': '~:stroke-color',
  'strokesOpacity': '~:stroke-opacity',
  'strokeColorGradient': '~:stroke-color-gradient',
  'strokesStyle': '~:stroke-style',
  'strokesWidth': '~:stroke-width',
  'hidden': '~:hidden',
  'shadow': '~:shadow',
  'style': '~:style',
  'offset': '~:offset',
  'offsetX': '~:offset-x',
  'offsetY': '~:offset-y',
  'blur': '~:blur',
  'spread': '~:spread',
  'color': '~:color',
  'opacity': '~:opacity',
  'proportion': '~:proportion',
  'selrect': '~:selrect',
  'rect': '~#rect',
  'height': '~:height',
  'x1': '~:x1',
  'y1': '~:y1',
  'x2': '~:x2',
  'y2': '~:y2',
  'fills': '~:fills',
  'fillColor': '~:fill-color',
  'fillColorGradient': '~:fill-color-gradient',
  'startX': '~:start-x',
  'startY': '~:start-y',
  'endX': '~:end-x',
  'endY': '~:end-y',
  'stops': '~:stops',
  'fillImage': '~:fill-image',
  'mtype': '~:mtype',
  'keepAspectRatio': '~:keep-aspect-ratio',
  'fillOpacity': '~:fill-opacity',
  'ry': '~:ry',
  'r1': '~:r1',
  'r2': '~:r2',
  'r3': '~:r3',
  'r4': '~:r4',
  'value': '~:value',
  'command': '~:command',
  'params': '~:params',
  'c1x': '~:c1x',
  'c1y': '~:c1y',
  'c2x': '~:c2x',
  'c2y': '~:c2y',
  'textAlign': '~:text-align',
  'verticalAlign': '~:vertical-align',
  'textDecoration': '~:text-decoration',
  'textTransform': '~:text-transform',
  'letterSpacing': '~:letter-spacing',
  'lineHeight': '~:line-height',
  'fontSize': '~:font-size',
  'fontStyle': '~:font-style',
  'fontWeight': '~:font-weight',
  'fontFamily': '~:font-family',
  'fontVariantId': '~:font-variant-id',
  'text': '~:text',
  'obj': '~:obj',
  'shapes': '~:shapes',
  'changes': '~:changes',
  'operations': '~:operations',
  'changesWithMetadata': '~:changes-with-metadata',
  'hintOrigin': '~:hint-origin',
  'frames': '~:frames',
  'option': '~:option',
  'set': '~#set',
  'sessionId': '~:session-id',
  'fileId': '~:file-id',
  'pageId': '~:page-id',
  'saveUndo': '~:save-undo?',
  'stackUndo': '~:stack-undo?',
  'revn': '~:revn',
  'features': '~:features',
  'attr': '~:attr',
  'val': '~:val',
  'ignoreGeometry': '~:ignore-geometry',
  'ignoreTouched': '~:ignore-touched',
} as const;

// 需要与WebComponent原子组件css对象双向同步的属性键名，除此之外的属性均忽略不管.
export const SYNC_KEYS: any[] = [
  ShapeConstants.hidden,
  ShapeConstants.type,
  ShapeConstants.x, ShapeConstants.y, ShapeConstants.width, ShapeConstants.height, ShapeConstants.selrect,
  ShapeConstants.fills, ShapeConstants.strokes, ShapeConstants.shadow,
  ShapeConstants.rx, ShapeConstants.ry, ShapeConstants.r1, ShapeConstants.r2, ShapeConstants.r3, ShapeConstants.r4,
  ShapeConstants.content,
  ShapeConstants.rotation, ShapeConstants.blur,
];

// Penpot和WebComponent原子组件的类型映射，仅包含Penpot对应的类型映射，不包含list等类型.
export const typeMap = new Map([
  [ShapeType.Frame, 'frame'],
  [ShapeType.Group, 'group'],
  [ShapeType.Rect, 'rectangle'],
  [ShapeType.Text, 'text'],
  [ShapeType.Circle, 'circle'],
  [ShapeType.Path, 'path'],
]);
